import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { AI } from '@/screens/AI';

//data-helpers
import {
  JsonLd,
  Organization,
  SoftwareApplication,
} from '@/datafiles/micro-data';

const lifecycle_content = {
  title: (
    <>
      Looking for a TMS or YMS? <br />
      <span>Get a unified platform.</span>
    </>
  ),
  numbers: false,
};

export default function Main() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight AI, autonomous transportation execution, AI-native TMS, freight automation, dock scheduling AI, freight experts, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/"
        title="Loadsmart AI | Logistics AI for Freight & Warehouse"
        description="Loadsmart AI runs freight and warehouse work end to end: TMS quoting, tendering, Opendock scheduling, docs, claims."
        openGraph={{
          url: 'https://loadsmart.com/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/loadsmart-ai-card.png`,
              width: 1200,
              height: 630,
              alt: 'Loadsmart AI',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <JsonLd data={SoftwareApplication} />
      <AI lifecycle_content={lifecycle_content} />
    </>
  );
}
